import { PracticeToolIcon } from "../practice-tool-icon";

type Name =
  | "apps"
  | "people"
  | "home"
  | "practice"
  | "weaknesses"
  | "tools"
  | "stores"
  | "events"
  | "bell"
  | "arrow"
  | "pin"
  | "article"
  | "profile"
  | "shop";
type SharedName =
  | "people"
  | "shop"
  | "weaknesses"
  | "tools"
  | "stores"
  | "events";

const paths: Record<Exclude<Name, SharedName>, React.ReactNode> = {
  apps: (
    <>
      {[4, 13].flatMap((x) =>
        [4, 13].map((y) => (
          <rect key={`${x}-${y}`} x={x} y={y} width="7" height="7" rx="1" />
        )),
      )}
    </>
  ),
  home: (
    <>
      <path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z" />
    </>
  ),
  practice: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />
    </>
  ),
  arrow: (
    <>
      <path d="M5 12h14m-6-6 6 6-6 6" />
    </>
  ),
  pin: (
    <>
      <path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </>
  ),
  article: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </>
  ),
  profile: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21v-1a8 8 0 0 1 16 0v1" />
    </>
  ),
};
export function PlayerIcon({ name, size = 22 }: { name: Name; size?: number }) {
  if (
    name === "people" ||
    name === "shop" ||
    name === "weaknesses" ||
    name === "tools" ||
    name === "stores" ||
    name === "events"
  ) {
    return <PracticeToolIcon name={name} size={size} />;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {paths[name]}
    </svg>
  );
}
